export const ACCEPT_FILE_FORMATS = 'image/png, image/jpeg, image/jpg,';
export const MAX_SIZE_OF_ATTACHMENT = 1024 * 1024 * 15; // 15MB
export const MIN_IMAGE_WIDTH = 1440;
export const MIN_IMAGE_HEIGHT = 900;
